import * as React from "react";
function SvgFacebookReactionLove(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={23.94} cy={24} r={16} fill="#fff" />
      <path
        d="M24 0a24 24 0 1024 24A24 24 0 0024 0zm14.75 22.29C36.75 31.38 24 37.74 24 37.74S11.29 31.38 9.26 22.29c-.77-3.44 1.07-9.87 7.37-9.87 6.55 0 7.37 5.28 7.37 5.28s.82-5.28 7.37-5.28c6.31 0 8.15 6.43 7.38 9.87z"
        fill="#ea556a"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebookReactionLove);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
